import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './presentation/pages/login.page';
import Home from './presentation/pages/home.page';
import DestinationAccounts from './presentation/pages/destination-accounts.page';
import ProtectedLayout from './layouts/layout';
import MyWages from './presentation/pages/my-wages.page';
import PaymentHistory from './presentation/pages/payment-history.page';
import { AuthProvider, useAuth } from './presentation/components/autentication-context.component';
import TransactionDetails from './presentation/pages/transaction-details.page';
import Profile from './presentation/pages/profile.page';
import TransactionConfirmation from './presentation/pages/transaction-confirmation.page';
import { logout } from './services/auth.service';

const AppContent: React.FC = () => {
  const { token, updateToken, clearAuthData } = useAuth();

  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [showRegister, setShowRegister] = useState<boolean>(false);

  useEffect(() => {
    if (token) {
      setIsLoggedIn(true);
    }
  }, [token]);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = async () => {
    try {
      await logout(token!, updateToken);
      clearAuthData();
    } catch (error) {
    } finally {
      setIsLoggedIn(false);
    }
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Rutas Protegidas */}
          {isLoggedIn && token ? (
            <>
              <Route path="/home" element={<ProtectedLayout onLogout={handleLogout}><Home /></ProtectedLayout>} />
              <Route path="/accounts" element={<ProtectedLayout onLogout={handleLogout}><DestinationAccounts handleLogout={handleLogout} /></ProtectedLayout>} />
              <Route path="/mywages" element={<ProtectedLayout onLogout={handleLogout}><MyWages handleLogout={handleLogout} /></ProtectedLayout>} />
              <Route path="/history" element={<ProtectedLayout onLogout={handleLogout}><PaymentHistory handleLogout={handleLogout} /></ProtectedLayout>} />
              <Route path="/transaction-confirmation" element={<ProtectedLayout onLogout={handleLogout}><TransactionConfirmation handleLogout={handleLogout} /></ProtectedLayout>} />
              <Route path="/transaction-details" element={<ProtectedLayout onLogout={handleLogout}><TransactionDetails /></ProtectedLayout>} />

              <Route path="/profile" element={<ProtectedLayout onLogout={handleLogout}><Profile handleLogout={handleLogout} /></ProtectedLayout>} />
              <Route path="*" element={<Navigate to="/home" replace />} />
            </>
          ) : (
            <>
              <Route path="/" element={<Login onLoginSuccess={handleLoginSuccess} />} />
              {/* <Route path="/register" element={<Register />} />
              <Route path="/create-employee" element={<CreateEmployeePage />} /> */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          )}
        </Routes>
      </div>
    </Router>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;